import { createContext, useContext } from "react";
import { useSelector } from "react-redux";
import BIZ_TYPE_KEYS from "languages/bizTypeKeys";
import { useTranslation } from "react-i18next";

// יצירת קונטקסט מרכזי לסוג העסק
export const BusinessTypeContext = createContext(null);

export const BusinessTypeProvider = ({ children }) => {
  const businessType = useSelector((state) => state?.biz?.data?.type);
  return (
    <BusinessTypeContext.Provider value={businessType}>
      {children}
    </BusinessTypeContext.Provider>
  );
};

// Hook לשימוש בתרגומים מותאמים לסוג העסק
export const useBizTypeTranslation = () => {
  const { t } = useTranslation();
  const businessType = useContext(BusinessTypeContext);

  const bt = (key) => {
    const businessKey = BIZ_TYPE_KEYS[key]?.[businessType] || key;
    return t(businessKey);
  };

  return { bt };
};
